export const DEFAULT_THEME = {
  primaryColor: "#473798",
  secondaryColor: "#4aabcf"
};
